import axios from 'api/axios'
import { useCallback, useEffect, useState } from 'react'

/**
 * @module FetchHooks
 */

/**
 * Fetch the calendar data for the user
 * @param {Object} props - The component props
 * @param {number} props.year - The year to see the calendar
 * @param {number} props.month - The month to see the calendar
 * @param {boolean} props.showRequested - Show requested dates
 * @param {UserToHandle} [props.user] - The user to make the request
 * @returns {UseFetchHookResponse<any>}
 */
const useFetchTeam = (year, month, showRequested) => {
  const [response, setResponse] = useState({})
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)

  const fetchData = useCallback(() => {
    setLoading(true)
    setError(null)
    axios
      .get(`/calendarioequipo/?y=${year}&m=${month}&r=${showRequested ? 'S' : 'N'}`)
      .then((request_response) => {
        const data = request_response.data
        setResponse(data)
      })
      .catch((error) => setError(error))
      .finally(() => setLoading(false))
  }, [year, month, showRequested])

  useEffect(() => {
    fetchData()
  }, [year, month, showRequested, fetchData])

  return { response, error, loading }
}

export default useFetchTeam
